module.exports = __webpack_public_path__ + "static/img/davis_pictgrid30_920x870.72223b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/davis_pictgrid30_920x870.jpg
// module id = B0Jb
// module chunks = 0